import { MarkNamespace, PointRiskLevel } from "@bennara/shared";

/**
 * Billboard dot colour for a mole, or a V1 point with no type.
 * Normal and monitor stay unmarked. Non-mole types get no dot.
 * High and critical share one red so the body only shows three risk steps.
 */
export const getRiskDotColor = (
  riskLevel: PointRiskLevel,
  type?: MarkNamespace.Type,
): string | null => {
  if (type && type !== MarkNamespace.Type.MOLE) return null;

  switch (riskLevel) {
    case PointRiskLevel.WARNING:
      return window.colors.riskWarning;
    case PointRiskLevel.HIGH_RISK:
    case PointRiskLevel.CRITICAL:
      return window.colors.riskCritical;
    default:
      return null;
  }
};
